var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"step",style:(`background-color:${_vm.color}; width:${_vm.width}`)},[_c('v-row',{staticClass:"justify-between pa-3",attrs:{"no-gutters":""}},[_c('v-col',[_vm._v(_vm._s(_vm.text))]),_c('v-col',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.qtd))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }